export const modules = import.meta.glob([ './messages/*.json', '!./messages/*.source.*' ], { import: 'default' })
